export default __webpack_public_path__ + "img/profile.56ca86c1.svg";